module.exports = __webpack_public_path__ + "img/zhuanli6.7e37a348.png";